/* eslint-disable */

<template>
  <div class="b-kyc-landing-container">
    <div></div>
    <div v-if="errorMessage">
      <h3 style="text-align: center">Error in fetching data, Please reload the page</h3>
    </div>
    <div style="{padding:15px}" v-else>
      <div class="b-kyc-landing-container__nav">
        <div
          class="b-kyc-landing-container__nav-tab"
          v-for="tab in tabs"
          :key="tab.name"
          v-on:click="changeCurrentTabHandler(tab.name)"
        >
          <div class="b-kyc-landing-container-heading__row">
            <h2 class="b-kyc-landing-container-heading">{{tab.name}}</h2>
            <div v-if="tab.totalCount !==null">
              <h2 class="b-kyc-landing-container-heading">({{tab.totalCount}})</h2>
            </div>
            <!-- <div v-if="tab.name == 'CKycVerificationPending'" >
              <a href v-on:click.stop.prevent="showCKycData('verification_pending')" 
                :class="{'b-kyc-data-link__active': allData === false}" >2w</a> |
              <a href v-on:click.stop.prevent="showCKycData((tab.name == 'Submitted')? 'submitted': 'rejected')"
                 :class="{'b-kyc-data-link__active': allData === true}" >All</a>
            </div> -->
          </div>
          <div :class="{'b-skyc-landing-container__active': currentTab === tab.name }"></div>
          <!-- <h1 >KYC Details</h1> -->
        </div>
      </div>
      <div v-if="ckyc_details.length>0">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Id</th>
              <th>Name</th>
              <th>PAN <input type="search" v-model="searchByPan" style="margin-left:10px;" placeholder="Search by PAN.." class="bordered"></th>
              <th>
                Created Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('created_at','desc')"
                  v-if="sortByCreatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-kyc-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('created_at','asc')"
                  
                  v-else-if="sortByCreatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('created_at','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>
                Update Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updated_at','desc')"
                  
                  v-if="sortByUpdatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-kyc-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updated_at','asc')"
                
                  v-else-if="sortByUpdatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('updated_at','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>Email id <input type="search" v-model="searchByEmail" style="margin-left:10px;" placeholder="Search by email.." class="bordered"></th>
              <th
                v-if="$route.params.status=='RejectedByAdmin' || $route.params.status=='RejectedByCVL'"
              >Error Message</th>
              <th @click="removeFilter">
                Kyc Source
                <span v-if="filterFlag">*</span>
              </th>
              <th>
                Generated Source
              </th>
              <th>
                Ckyc No
              </th>              
              <th>
                Status
              </th> 
              <th>
                Remarks
              </th>                             
            </tr>
          </thead>
          <tbody>
            <tr v-for="(kyc,index) in all_kyc" :key="kyc.id">
              <td>{{index+1}}</td>
              <td>
                <a href v-on:click.stop.prevent="ckycIdDetail(kyc.id)">{{kyc.id}}</a>
              </td>
              <td>{{kyc.attributes.fullname}}</td>
              <td>{{kyc.attributes.pan_number}}</td>
              <td>{{kyc.attributes.created_at | datetimeFormat}}</td>
              <td>{{kyc.attributes.updated_at | datetimeFormat}}</td>
              <td>{{kyc.attributes.email}}</td>
              <td>{{kyc.attributes.source}}</td>
              <td>{{kyc.attributes.generated_source}}</td>
              <td>{{kyc.attributes.ckyc_no}}</td>
              <td>{{kyc.attributes.status}}</td>
              <td>{{kyc.attributes.remarks}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="b-kyc-not-found--msg">No record found</div>
    </div>
  </div>
</template>
<script>
import {  mapState } from "vuex";

import Moment from "moment";

export default {
  data() {
    return {
      ckyc_details: [],
      loaded: false,
      kycDetails: null,
      filterFlag: false,
      createdDate_asc: null,
      updatedDate_asc: null,
      errorMessage: false,
      // tabs: ["Pending", "Submitted", "RejectedByAdmin", "RejectedByCVL"],
      tabs: [
        { name: "CKycVerificationPending", totalCount: null },
        { name: "CKycUpdateUploadPending", totalCount: null },
        { name: "CKycUploaded", totalCount: null },
        { name: "CKycInProgress", totalCount: null },
        { name: "CKycFailednRejected", totalCount: null },
        { name: "CKycActive", totalCount: null },
      ],
      currentTab: { name: "CKycVerificationPending", totalCount: null },
      allData: false,
      searchByPan: null,
      searchByEmail: null
    };
  },
  mounted() {

    this.$store.commit("resetTabCkyc");
    this.$store.commit('set_admin_partner', this.$route.params.partner)
    this.$store.commit('set_kyc_verification_type', 'ckyc')
    this.status = this.$route.params.status;

    // console.log("admin partner ckyc",this.admin_partner)

    let ckyc_status = ''
    switch (this.status) {
    case "CKycVerificationPending":
      ckyc_status = "verification_pending"
      break;
    case "CKycUpdateUploadPending":
      ckyc_status = "update_upload_pending"
      break;
    case "CKycUploaded":
      ckyc_status = "uploaded"
      break;
    case "CKycFailednRejected":
      ckyc_status = "failed_and_rejected"
      break;
    case "CKycActive":
      ckyc_status = "active"
      break;
    case "CKycInProgress":
      ckyc_status = "in_progress"
      break;
  }   
    this.$store
      .dispatch("fetchCkycData", ckyc_status)
      .then(() => {
        for (let i = 0; i < this.ckycData.length; i++) {
          switch (this.ckycData[i].attributes.status) {
            case "update_verification_pending":
              this.tabs[0].totalCount++;
              break;
            case "upload_verification_pending":
              this.tabs[0].totalCount++;
              break;              
            case "update_pending":
              this.tabs[1].totalCount++;
              break;
            case "upload_pending":
              this.tabs[1].totalCount++;
              break;              
            case "uploaded":
              this.tabs[2].totalCount++;
              break;
            case "in_progress":
              this.tabs[3].totalCount++;
              break;              
            case "failed":
              this.tabs[4].totalCount++;
              break;
            case "rejected":
              this.tabs[4].totalCount++;
              break;
            case "active":
              this.tabs[5].totalCount++;
              break;
          }
        }
        this.showCKycList();
      })
      .catch(() => (this.errorMessage = true));
  },
  methods: {

    ckycIdDetail: function(id) {
      this.$router.push({ name: "ckyc-details-id", params: { id: id , partner: this.admin_partner} });
      this.$store.commit("removeUserDetails");
    },

    // filterStatus(status) {
    //   this.filterFlag = true;
    //   this.ckyc_details = this.ckyc_details.filter(
    //     element => element.kyc_form_check_status === status
    //   );
    // },
    removeFilter() {
      this.filterFlag = false;
      this.showCKycList();
    },
    showCKycList() {
      this.currentTab = this.$route.params.status;

      // let ckyc_status = 'verification_pending'
      // switch (this.currentTab) {
      // case "CKycVerificationPending":
      //   ckyc_status = "verification_pending"
      //   break;
      // case "CKycUpdateUploadPending":
      //   ckyc_status = "upload_pending"
      //   break;
      // case "CKycUploaded":
      //   ckyc_status = "uploaded"
      //   break;
      // case "CKycFailednRejected":
      //   ckyc_status = "failed"
      //   break;
      // case "CKycActive":
      //   ckyc_status = "rejected"
      //   break;
      // case "CKycInProgress":
      //   ckyc_status = "in_progress"
      //   break;
      // }


      switch (this.currentTab) {
        case "verification_pending":
          // eslint-disable-next-line no-case-declarations
          let list = this.ckycData.filter(
             element => ["update_verification_pending", "upload_verification_pending"].includes(element.attributes.status)
            //element => element.attributes.status === "verification_pending"
          );
          list.sort((a,b)=> b.attributes.status - a.attributes.status)
          this.ckyc_details = list
          break;

        case "upload_pending":
         this.ckyc_details = this.ckycData.filter(
            element => ["update_pending", "upload_pending"].includes(element.attributes.status)
          );

          break;          
        case "uploaded":
         this.ckyc_details = this.ckycData.filter(
            element => ["uploaded"].includes(element.attributes.status)
          );

          break;
        case "failed":
         this.ckyc_details = this.ckycData.filter(
            element => ["failed","rejected"].includes(element.attributes.status)
          );
          break;

        case "in_progress":
         this.ckyc_details = this.ckycData.filter(
            element => ["in_progress"].includes(element.attributes.status)
          );
          break;

        case "active": 
          this.ckyc_details = this.ckycData.filter(
            element => ["active"].includes(element.attributes.status)
          );
          break;
        default:
          this.ckyc_details = this.ckycData;
      }
  
    },
    //not used
    showCKycData(type) {
      this.tabs[0].totalCount = 0;
      this.tabs[1].totalCount = 0;
      this.tabs[2].totalCount = 0;
      this.tabs[3].totalCount = 0;
      this.tabs[4].totalCount = 0;      
      let route_param = this.$route.params.status;
      // this.allData = true;

      // if(type == 'verification_pending') {
      //   route_param = "verification_pending";
      //   this.allData = false;
      // }
      // if(type == 'rejected') {
      //   route_param = "RejectedByAdmin";
      //   this.allData = false;
      // }
      this.$store
        .dispatch(`fetchCKycData`, type)
          .then(() => {
            for (let i = 0; i < this.kycData.length; i++) {
              switch (this.kycData[i].attributes.status) {
                case "verification_pending":
                  this.tabs[0].totalCount++;
                  break;
                case "upload_pending":
                case "uploaded":
                case "failed":
                case "rejected":                  
                  this.tabs[1].totalCount++;
                  break;
              }
            }
            this.changeCurrentTabHandler(route_param);
            this.showCKycList();
          })
        .catch(() => (this.errorMessage = true));
    },

    sortByDate(type, sortOrder) {
      let data = [...this.ckyc_details];
      if (type === "created_at") {
        // this.updatedDate_asc = null;
        this.$store.commit("setSortingByDate",{sortByUpdatedDate:null});
        if (sortOrder === "asc") {
          // this.createdDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:true});
          data.sort((a, b) => new Date(b.attributes[type]) - new Date(a.attributes[type]));
        } else {
          // this.createdDate_asc = false;
            this.$store.commit("setSortingByDate",{sortByCreatedDate:false});
          data.sort((a, b) => new Date(a.attributes[type]) - new Date(b.attributes[type]));
        }
      }
      if (type === "updated_at") {
        // this.createdDate_asc = null;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:null});
        if (sortOrder === "asc") {
          // this.updatedDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:true});
          data.sort((a, b) => new Date(b.attributes[type]) - new Date(a.attributes[type]));
        } else {
          // this.updatedDate_asc = false;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:false});
          data.sort((a, b) => new Date(a.attributes[type]) - new Date(b.attributes[type]));
        }
      }

      this.ckyc_details = data;
    },
    changeCurrentTabHandler(tab) {
      this.currentTab = tab;
      this.$router.replace({ name: 'ckyc-details', params: {status: tab, partner: this.admin_partner}});
      this.showCKycList();
    },
    checkKycStatus(status){
         switch (status) {
            case "2":
              return 'Pending'
            case "4":
            case "5":
              return 'Submitted'
            case "3":
              return 'Rejected By Admin'
            case "6":
              return 'Rejected By CVL'
          }
    }
  },
  computed: {
    ...mapState({
      ckycData: state => state.ckycDetails.ckycData,
      sortByCreatedDate: state => state.kycDetails.sortByCreatedDate,
      sortByUpdatedDate: state => state.kycDetails.sortByUpdatedDate,
       admin_partner: state => state.kycLogin.admin_partner,
       kyc_verification_type: state => state.kycLogin.kyc_verification_type
    }),
    getDetails() {
      return this.$store.state.kycDetails.ckycData;
    },
    // loading() {
    //   return {
    //     loader: this.$store.state.kycDetails.loading
    //   };
    // },
    all_kyc() {
      if(this.searchByPan) {
        return this.ckyc_details.filter(obj => {
                if(obj.attributes.pan_number) {
                  return (obj.attributes.pan_number.indexOf(this.searchByPan.toUpperCase()) > -1)
                } else {
                  return false;
                }
              });
      } else if(this.searchByEmail) {
        return this.ckyc_details.filter(obj => {
                if(obj.attributes.email) {
                  return (obj.attributes.email.indexOf(this.searchByEmail) > -1)
                } else {
                  return false;
                }
              });
      } else {
        return this.ckyc_details;
      }
    }
  },
  watch: {
    "$route.params.status": function(status) {
      this.currentTab = status;
      this.showCKycList();
    }
  },

  filters: {
    datetimeFormat: function(value) {
      if (value) {
        return Moment(value).format("DD/MM/YYYY");
      }
    },
    booleanFilter(value){
    return value? " YES ":" NO ";
    },

  },
};
</script>

<style scoped>
.b-kyc-landing-container {
  margin-top: 40px;
}
.b-kyc-landing-container-heading {
  text-align: center;
  margin-bottom: 8px;
  cursor: pointer;
}
.b-kyc-landing-container__nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 45px;
}
.b-skyc-landing-container__active {
  border: solid 1.5px #2b3d51;
}
tbody tr:hover {
  background-color: aliceblue;
}

table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.b-kyc-landing-container__sort-icon {
  width: 12px;
  height: 12px;
}
.b-kyc-not-found--msg {
  display: flex;
  justify-content: center;
}
.b-kyc-landing-container-heading__row {
  display: flex;
}
.b-kyc-rejected{
color: #ff0000
}
.b-kyc-data-link__active {
  text-decoration: none;
}

/* td a{
  text-decoration: none;
} */

/* Safari */
</style>